import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminFounding500 = lazy(() => import("@/pages/admin/AdminFounding500"));
import { AdminLayout } from "@/components/admin/AdminLayout";
export const Route = createFileRoute("/admin/founding-500")({
  component: () => (
    <AdminLayout requiredPermission="view_audit_logs">
      <AdminFounding500 />
    </AdminLayout>
  ),
});
